import { render, staticRenderFns } from "./Scanner.vue?vue&type=template&id=50835f78&scoped=true"
import script from "./Scanner.vue?vue&type=script&lang=js"
export * from "./Scanner.vue?vue&type=script&lang=js"
import style0 from "./Scanner.vue?vue&type=style&index=0&id=50835f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50835f78",
  null
  
)

export default component.exports